import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MarkdownModule } from 'ngx-markdown';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DemoDialogComponent } from './demo-dialog.component';
import { MaterialDesignModule } from './material-design.module';

@NgModule({
  declarations: [AppComponent, DemoDialogComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    MarkdownModule.forRoot(),
    MaterialDesignModule,
    ReactiveFormsModule,
  ],
  entryComponents: [DemoDialogComponent],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
